export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ecommerce plugin',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  features: {
    /**
     * @description Shows meta attributes on the CC narrow item card.
     * Needed to reuse `narrowItemCard` component on across different sites and configure the item card parts which vary on different sites
     * @author Tanya Fonina
     * @expires
     */
    'metaInfo:showAttributes': true,
    /**
     * @description Displays a loading cover over the search results to prevent incorrect variant from displaying.
     * @author Luke Jones / Tanya Fonina
     * @expires When no more search experiments are occurring.
     */
    'experiments:loading-cover': true,
    /**
     * @description An experiment between key features and item attributes on item cards.
     * @author Luke Jones
     * @expires When CC Phase 4 experiment has been completed.
     */
    searchItemAttributes: true,
    /**
     * @description An experiment between V1/new search results and updated more narrow cards and styling.
     * @author Luke Jones
     * @expires When all item cards have been migrated to a narrow item card.
     */
    narrowItemCard: true
  },
  filterOrder: [
    'category',
    'tags',
    'price',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added'
  ]
}
